import { getEndpoint, type ServiceName } from '@ubi/js-utils/environment'
import { isKeyOf } from '@ubi/js-utils/utils'
import { INJECTIONS } from './init/injections'

export const VERSIONNED_SERVICES = [
    'BillingService',
    'ConsumptionService',
    'InterbobService',
    'MdmConfigurationService',
    'MobilityAccountService',
    'ObservatoryService',
    'PassengerInformationFareService',
    'PassengerInformationNetworkService',
    'PaymentService',
    'SubscriptionService',
    'UbiBoCompanyService',
    'UbiBoFareService',
] as const

/**
 * BillingService => billing
 * PassengerInformationFareService => passenger-information-fare
 */
const getServiceSlug = (serviceName: string) => {
    return serviceName
        .replace(/Service$/, '')
        .replaceAll(/(?<=\w)([A-Z])/g, '-$1')
        .toLowerCase()
}

type ServiceOption = { title: string; key: ServiceName }

export const VERSIONNED_SERVICES_OPTIONS: ServiceOption[] =
    VERSIONNED_SERVICES.map((serviceName: ServiceName) => ({
        title: getServiceSlug(serviceName),
        key: serviceName,
    }))

const VERSIONNED_SERVICE_SET = new Set<ServiceName>(VERSIONNED_SERVICES)

export const isVersionnedService = (serviceName: ServiceName) => {
    return VERSIONNED_SERVICE_SET.has(serviceName)
}
export const resolveEndpoint = (service: ServiceName) => {
    const { baseUrls, gatewayBaseUrl } = INJECTIONS

    if (gatewayBaseUrl && isVersionnedService(service)) {
        return `${gatewayBaseUrl}/${getServiceSlug(service)}`
    }

    if (isKeyOf(service, baseUrls)) {
        return baseUrls[service]
    }

    return getEndpoint(service)
}
